export const steps = ['Ваш бизнес', 'Юридическая информация', 'Контакты']
